import Tag from "~/common/components/Tag/Tag";
import { Stack, Typography } from "~/common/mui";
import { useTranslation } from "react-i18next";
import { OrderLineHeader } from "../common/components/v2/OrderAndQuoteSharedStyles";
import type { QuoteLineMO } from "../common/components/v2/models";
import type { RenderCboxFn } from "../common/components/v2/QuoteTable/types";
import { getQuoteLineStatus } from "../common/utils/util";

interface Props {
  quoteLine: QuoteLineMO;
  includeQuoteLine: boolean;
  renderCheckbox?: RenderCboxFn;
  hidden?: boolean;
  alternative?: boolean;
}

const QuoteLineHeaderSection = ({ quoteLine, includeQuoteLine, renderCheckbox }: Props) => {
  const { t } = useTranslation();

  const quotePart = includeQuoteLine && quoteLine.parts[0];

  return (
    <OrderLineHeader>
      <Stack direction="row" gap={1} alignItems="center">
        {renderCheckbox?.(quoteLine)}
        <Stack gap={1} flexDirection={"row"}>
          <Typography color="text.label">{t("quoteList.quote.line.number")}</Typography>
          <Typography color="text.secondary">{quoteLine.lineNo}</Typography>
        </Stack>
      </Stack>

      {quotePart && (
        <Tag variant={getQuoteLineStatus(quoteLine.status)}>{t(`codes.quoteLineItemStatus.${quoteLine.status}`)}</Tag>
      )}
    </OrderLineHeader>
  );
};

export default QuoteLineHeaderSection;
